<template>
  <div id="ringtone_item" class="flex items-center gap-2 min-w-0">
    <button
      class="flex items-center justify-center flex-shrink-0"
      @click.stop="$emit('play', ringtone)"
    >
      <ThemeImage
        :icon="isPlaying ? imageNames.CIRCLE_PAUSE_ICON : imageNames.CIRCLE_PLAY_ICON"
        alt="play-pause"
        class="size-5"
      />
    </button>

    <span class="text-sm text_color truncate capitalize">
      {{ ringtone?.recording_name }}
      <span v-if="ringtone?.is_primary" class="secondary_color">(Default)</span>
    </span>
  </div>
</template>

<script setup>
import ThemeImage from "@/src/components/ThemeImage.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

defineProps({
  ringtone: {
    type: Object,
    default: null,
  },
  isPlaying: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["play"]);
</script>
